import React from 'react';
import { Form, TimePicker } from 'antd';
import AppModal from '@/pages/inside/tenant/AppModal';
import Select from '@/components/ui/Select';
import { Button } from '@/components/ui/Button';
import { CreateRoleModalBody, CreateRoleModalFooter } from '@/pages/inside/tenant/style';

export const EditAttendanceModal = ({
    open,
    onCancel,
    editingRecord,
    form,
    onSubmit,
    statusOptions,
    loading,
}) => {
    const dateStr = editingRecord?.date ? String(editingRecord.date).slice(0, 10) : '';
    const titleText = `Edit Attendance — ${editingRecord?.userName ?? ''} ${dateStr ? `(${dateStr})` : ''}`;

    return (
        <AppModal
            size="md"
            title={titleText}
            open={open}
            onCancel={onCancel}
            footer={null}
            styles={{ body: { paddingTop: 8 } }}
        >
            <CreateRoleModalBody>
                <Form form={form} layout="vertical">
                    <Form.Item name="status" label="Status">
                        <Select placeholder="Status" options={statusOptions} />
                    </Form.Item>
                    <Form.Item name="checkIn" label="Check in (e.g. 09:00 AM)">
                        <TimePicker style={{ width: '100%' }} use12Hours format="h:mm a" />
                    </Form.Item>
                    <Form.Item name="checkOut" label="Check out (e.g. 06:00 PM)">
                        <TimePicker style={{ width: '100%' }} use12Hours format="h:mm a" />
                    </Form.Item>
                </Form>
            </CreateRoleModalBody>
            <CreateRoleModalFooter>
                <Button $primary={false} onClick={onCancel} $padding="10px 16px" $size="14px">
                    Cancel
                </Button>
                <Button
                    $primary
                    $blackOnLight
                    onClick={onSubmit}
                    loading={loading}
                    $padding="10px 16px"
                    $size="14px"
                >
                    Save Changes
                </Button>
            </CreateRoleModalFooter>
        </AppModal>
    );
};

export default EditAttendanceModal;
